import { render, staticRenderFns } from "./ColorIconSVG.vue?vue&type=template&id=480d9a1a&"
import script from "./ColorIconSVG.vue?vue&type=script&lang=js&"
export * from "./ColorIconSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports